import $ from 'jquery/src/jquery';

export default () => {
    // const nodeSelectors = {
    //     sectionContainer: '[js-form="section-container"]',
    // }

    function init() {
        if (!document.querySelector('.wpcf7')) {
            return
        }

        let wpcf7Elm = document.querySelectorAll( '.wpcf7' );

        wpcf7Elm.forEach(function (form) {
            // console.log(form)
            $(form).find('form').append('<div class="gl-loader-holder"><div class="gl-loader-holder__loader"></div></div>')

            // wrap specific elements
            let inputs = $(form).find('input[type=text], input[type=email], input[type=phone], input[type=date], textarea');
            inputs.each(function () {
                let $element = $(this)
                let nodeName = $element[0].nodeName
                $element.wrap('<span class="gl-form__element"></span>')
            })

            // File Input
            // let fileInputs = $(form).find('input[type=file]')
            // if( fileInputs ) {
            //     fileInputs.each(function () {
            //         let fileInput = $(this)
            //         fileInput.after('<div class="file-input-text"></div>')
            //         fileInput.wrap('<button type="button" class="gl-link">Upload file</button>')
            //         // fileInput.parent().after('')
            //
            //         let fileInputText = fileInput.parent().next()
            //
            //
            //         // fileInput.click(function(){ });
            //
            //         fileInput.change(function() {
            //             fileInputText.text(fileInput[0].files[0].name);
            //         });
            //
            //         form.addEventListener( 'wpcf7mailsent', function( event ) {
            //             fileInputText.text('');
            //         }, false );
            //     })
            // }
            // File Input END
        })

        // When email is sent
        document.addEventListener( 'wpcf7mailsent', function( event ) {
            // Hide form and show thank you message

            let formId = event.detail.unitTag
            let formEl = $('#' + formId)
            let parent = formEl.parent()
            let formTitle = parent.find('.form-title')
            formTitle.slideUp()

            let customMessageHolder = parent.find('.custom-form-thank-you-message')

            if( !customMessageHolder.length ) {
                // If custom hidden message on page doesn't exist show contact form 7 message
                parent.append('<div class="form-thank-you-message" style="display: none">' + event.detail.apiResponse.message + '</div>')

                formEl.slideUp(function () {
                    setTimeout(function () {
                        let message = parent.find('.form-thank-you-message')
                        message.slideDown()
                        formEl.remove()
                    }, 100)
                });
            } else {
                // If custom hidden message on page exists show it
                formEl.slideUp(function () {
                    setTimeout(function () {
                        customMessageHolder.slideDown()
                        formEl.remove()
                    }, 100)
                });
            }

            $('body').addClass('form-message-is-sent')
        })
    }

    return Object.freeze({
        init,
    })
}